import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IArchiveResearchWorkItemRequest {
  workItemId: string;
  version: number;
  reason: string;
}

export const archiveResearchWorkItem = async ({
  workItemId,
  version,
  reason,
}: IArchiveResearchWorkItemRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/archival`,
    { version, reason }
  );

  return response.data;
};
